import { BuildClass } from '..';
import { React, _ } from '../../lib';
import { CJSX } from './meta-types';
import { stubTextarea } from './stubs';
import { Textarea } from './textbox';
import { VoiceRecorder } from './voice-recorder';
export const TextareaWithVoice = React.forwardRef((props, ref) => {
    const refInput = React.useRef(stubTextarea);
    React.useImperativeHandle(ref, () => refInput.current);
    const [voiceRecording, setVoiceRecording] = React.useState(false);
    const [isTranscribing, setTranscribing] = React.useState(false);
    return (React.createElement("div", { className: BuildClass([
            'ui5 ui5-textarea tailwind-wrapper',
            props.className,
        ]), style: { border: 'none', padding: '0px', margin: '0px' } },
        React.createElement("div", { className: "w-full h-full relative" },
            React.createElement("div", { className: "w-full h-full z-0" },
                React.createElement(Textarea, { ref: refInput, removeBaseClass: true, className: BuildClass([
                        'w-full h-full p-[3px] resize-none border border-[hsl(0,0%,75%)] text-[#000] pb-6',
                        props.classNameTextarea,
                    ]), ..._.omit(props, [
                        'ref',
                        'className',
                        'classNameTextarea',
                        'prompt',
                        'maxLength',
                        'disableVoiceInput',
                        'onFinishTranscribing',
                    ]) }),
                React.createElement("div", { className: BuildClass({
                        'absolute inline-flex bottom-[2px] right-[1px] p-1': true,
                        'text-xs text-[#888] select-none bg-[rgba(255,255,255,0.8)]': true,
                        'text-red-700': props.maxLength < props.value.length,
                    }), title: `Maximum length allowed: ${props.maxLength}` },
                    React.createElement("span", { className: "leading-4 mr-1" }, props.value.length),
                    React.createElement(InputProgressDonut, { className: "align-baseline", value: props.value.length, max: props.maxLength }),
                    React.createElement(CJSX, { cond: !(props.disableVoiceInput ?? false) },
                        React.createElement("button", { type: "button", className: BuildClass([
                                'group px-1 py-0 m-[-4px] ml-1 inline-block',
                                'hover:outline-1 hover:outline-blue-700 hover:bg-yellow-200',
                            ]), onClick: () => {
                                setVoiceRecording(true);
                            }, title: "Click to dictate text using your voice." },
                            React.createElement("img", { src: "/static/img/i8/ios16-microphone.svg", className: "w-5 h-5 opacity-70 group-hover:opacity-100" }))))),
            React.createElement(CJSX, { cond: voiceRecording },
                React.createElement("div", { className: BuildClass({
                        'w-[calc(100%-2px)] absolute bottom-[1px] left-[1px] z-10 bg-white': true,
                        collapse: isTranscribing,
                    }) },
                    React.createElement(VoiceRecorder, { className: "h-full w-full", prompt: props.prompt, autoStart: true, onSend: v => {
                            const value = `${props.value ?? ''}\n\n${v}`.trim();
                            props.onUpdate(value);
                            setVoiceRecording(false);
                            setTranscribing(false);
                            props.onFinishTranscribing?.(value);
                        }, onTranscribingStart: () => {
                            setTranscribing(true);
                        }, onCancel: () => {
                            setTranscribing(false);
                            setVoiceRecording(false);
                        } }))),
            React.createElement(CJSX, { cond: isTranscribing },
                React.createElement("div", { className: "w-[calc(100%-2px)] absolute bottom-[1px] left-[1px] z-20 bg-white text-center leading-6" }, "Transcribing...")))));
});
const InputProgressDonut = (props) => {
    const percentage = Math.min(props.value / props.max, 1);
    const hasExceeded = props.value > props.max;
    const colour = hasExceeded ? 'hsl(0, 100%, 50%)' : 'hsl(120, 100%, 30%)';
    return (React.createElement("div", { role: "progressbar", "aria-valuenow": props.value, "aria-valuemax": props.max, "aria-valuemin": 0, "aria-live": "polite", className: BuildClass([
            'relative inline-block w-4 h-4 rounded-full',
            'after:bg-white after:rounded-full after:w-2 after:h-2',
            props.className,
        ]), style: {
            background: `conic-gradient(${colour} ${percentage * 100}%, #DDDDDD 0%)`,
        } }));
};
//# sourceMappingURL=text-with-voice.js.map